import React from 'react';
import { groupTypeDotColor, resolveGroupDisplayLabel } from './groupTypeStyles';

/** Small type label with color dot (web cards, meta rows). */
const GroupsTypeBadge = ({
  groupType,
  displayLabel = null,
  variant = 'default',
  className = ''
}) => {
  const t = groupType || 'team';
  const label = resolveGroupDisplayLabel(t, displayLabel);
  const hasCustom = Boolean(String(displayLabel || '').trim());

  return (
    <span
      className={[
        'groups-type-badge',
        `groups-type-badge--${variant}`,
        hasCustom ? 'groups-type-badge--display-label' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span
        className="groups-type-badge-dot"
        style={{ background: groupTypeDotColor(t) }}
        aria-hidden="true"
      />
      {label}
    </span>
  );
};

export default GroupsTypeBadge;
